import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import "./CustomPaymentComponent.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import CircularProgress from "@material-ui/core/CircularProgress";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Your Stripe public key
const stripePromise = loadStripe("your_stripe_public_key_here");

const base64Img =
  "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";
const CustomPaymentComponent = (
  insuredName = "Test Henry",
  insuredAddress = "1201 canyon way 33414 wellingtion,FL",
  policyNumber = 23232,
  periodFrom = "May 1 2024",
  periodTo = "May 30 2024",
  premium = 232,
  limitOfLiability = [
    "$50,000 Any One Claim",
    "$100,000 Aggregate Limit",
    "$500 Deductible (Standard) or $2,500 (Contractor/Construction Industry Insureds)",
    "Deductible is not applicable to Legal Advice Service",
  ],
  coverage = [
    "24/7 Legal Advice Service",
    "Debt Recovery",
    "Contract Dispute",
    "Employment Disputes",
    "Employment Restrictive Covenants",
    "Legal Defence",
    "Property Disputes",
    "Personal Injury",
    "Tax Disputes",
    "Statutory License Protections",
  ]
) => {
  const [base64Image, setBase64Image] = useState("");

  useEffect(() => {
    // Fetch the base64 string from the text file
    fetch("/largeImageBase64.txt")
      .then((response) => response.text())
      .then((data) => {
        console.log("rextiy", data);
        // Update state with the loaded base64 string
        setBase64Image(data);
      })
      .catch((error) => {
        console.error("Error loading base64 string:", error);
      });
  }, []);

  const ddTemp = {
    content: [
      {
        // Stack for header and border
        stack: [
          {
            // Canvas for the border
            canvas: [
              {
                type: "rect",
                x: 0,
                y: -5,
                w: 515, // Width of the border - adjust as needed
                h: 90, // Height of the border - adjust as needed
                lineWidth: 1,
                lineColor: "black",
              },
            ],
            // Absolute position is required to place canvas behind the columns
            absolutePosition: { x: 40, y: 60 }, // Adjust position as needed
          },
          {
            // Header Columns
            columns: [
              {
                // Lloyds Logo Placeholder
                image:
                  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQMAAAD+wSzIAAAABlBMVEX///+/v7+jQ3Y5AAAADklEQVQI12P4AIX8EAgALgAD/aNpbtEAAAAASUVORK5CYII",
                width: 60,
                margin: [0, 10, 10, 0],
              },
              {
                // Insurance Details
                stack: [
                  {
                    text: "COMMERCIAL LEGAL EXPENSE INSURANCE",
                    bold: false,
                    fontSize: 12,
                  },
                  {
                    text: "Covered with certain Lloyd's Underwriters through Lloyd's Approved",
                    fontSize: 12,
                  },
                  { text: "Coverholder (“the Coverholder”):", fontSize: 12 },
                  { text: "Approved Casualty and Surety Inc.", fontSize: 12 },
                  {
                    text: "6601 Goreway Drive, Unit A, Mississauga ON L4V 1V6",
                    fontSize: 12,
                  },
                ],
                fontSize: 12,
                margin: [40, 7, 0, 0],
              },
            ],
            // Relative position to move the columns inside the border
            relativePosition: { x: 40, y: 15 }, // Adjust position as needed
          },
        ],
        // Required to prevent other content from overlapping with the header
        margin: [0, 0, 0, 50], // Bottom margin to push content below the header
      },

      {
        // Policy Notice
        text: "THIS POLICY CONTAINS A CLAUSE WHICH MAY LIMIT THE AMOUNT PAYABLE.",
        bold: true,
        fontSize: 18,
        alignment: "center",
        margin: [10, 80, 5, 5],
      },
      {
        // Policy Notice
        text: "DECLARATIONS",
        bold: true,
        fontSize: 15,
        alignment: "center",
        margin: [0, 30, 0, 15],
      },
      {
        // Declarations
        stack: [
          {
            text: "POLICY NO: " + policyNumber,
            alignment: "right",
            fontSize: 12,
            margin: [0, 0, 0, 10],
            bold: true,
          },
          {
            // When you want to combine text and styles, make sure each part is correctly structured
            text: [
              { text: "INSURED NAME: ", bold: true, fontSize: 12 },
              { text: "Joe", bold: false, fontSize: 12 },
            ],
          },
          {
            text: [
              { text: "INSURED ADDRESS: ", bold: true, fontSize: 12 },
              {
                text: "1201 Blue Jay Drive ,Toronto,Ontario,m5a 074",
                bold: false,
                fontSize: 12,
              },
            ],
          },
          {
            text: "PERIOD OF INSURANCE:",
            fontSize: 12,
            margin: [0, 0, 0, 0],
            bold: true,
          },
          {
            text: [
              { text: "from: ", bold: true, fontSize: 12 },
              { text: periodFrom, bold: false, fontSize: 12 },
            ],
            margin: [128, 0, 0, 0],
          },
          {
            text: [
              { text: "to: ", bold: true, fontSize: 12 },
              { text: periodTo, bold: false, fontSize: 12 },
            ],
            margin: [129, 0, 0, 10],
          },
          {
            text: [
              {
                text: "(both days at 12:01 a.m. Standard Time at the Address of the Insured).",

                fontSize: 10,
              },
            ],
            margin: [198, 0, 0, 10],
          },

          {
            text: [
              { text: "PREMIUM: ", bold: true, fontSize: 12 },
              {
                text: premium.toString(),
                bold: false,
                fontSize: 12,
                margin: [20, 0, 0, 20],
              },
            ],
          },

          {
            table: {
              headerRows: 1,
              widths: ["*", "auto"], // First column fills remaining space, second is as wide as its content

              body: [
                // Header row
                [
                  { text: "Type of Liability", style: "tableHeader" },
                  { text: "Amount", style: "tableHeader" },
                ],
                // Data rows
                ["Any One Claim", "$50,000"],
                ["Aggregate Limit", "$100,000"],
                ["Deductible (Standard)", "$500"],
                [
                  "Deductible (Contractor/Construction Industry Insureds)",
                  "$2,500",
                ],
                ["Deductible for Legal Advice Service", "Not Applicable"],
              ],
            },
            layout: "lightHorizontalLines", // This adds horizontal lines between rows
            margin: [0, 5, 0, 20], // Margins for the entire table
            style: "tableStyle",
          },
          {
            text: "POLICY COVERAGE:",
            fontSize: 14,
            margin: [0, 0, 0, 10],
            bold: true,
          },
          {
            ul: coverage.map((cover) => ({
              text: cover,
              fontSize: 14,
            })),
            margin: [20, 0, 0, 20],
          },
          {
            text: "The insurance contract consists of this Declarations page as well as all coverage wordings, riders, or endorsements that are attached hereto.",
            margin: [0, 10, 0, 0],
            fontSize: 12,
          },
        ],
      },
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
      },
      subheader: {
        fontSize: 15,
        bold: true,
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
      tableHeader: {
        bold: true,
        fontSize: 12,
        margin: [0, 5, 0, 5], // Top, Right, Bottom, Left
        alignment: "left",
      },
      tableStyle: {
        margin: [0, 5, 0, 15],
      },
    },
  };

  let { prospectID, insurerSelectedId, tax, brokerFees } = useParams();
  console.log(prospectID, insurerSelectedId);
  const [clientData, setClientData] = useState({
    serviceName: "Legal Malpractice",
    premium: 1000, // This would be your base service charge
    additionalFees: 150, // Sum of any additional fees
    taxRate: tax, // 8% tax
  });
  const [loading, setLoading] = useState(true);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [dd, setDd] = useState(ddTemp);
  const [total, setTotal] = useState(0);

  // Date change handler
  const handleDateChange = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (date > today) {
      setEffectiveDate(date);
    }
  };
  const isPaymentButtonDisabled = effectiveDate === null;
  async function generatePdf() {
    //works
    pdfMake.createPdf(dd).getBuffer((buffer) => {
      const blob = new Blob([buffer], { type: "application/pdf" });

      // Create a new FormData object and append the PDF blob as 'pdf'
      const formData = new FormData();
      formData.append("pdf", blob, "document.pdf");
      // Assuming prospectID and total are correctly defined somewhere in your script
      formData.append("prospectId", prospectID); // Include additional data as needed
      formData.append("price", total); // Assuming `total` holds the price for the PDF

      // The fetch API automatically sets the Content-Type to 'multipart/form-data'
      // and adds the boundary parameter correctly when you pass a FormData object.
      setPaymentLoading(true);
      fetch(process.env.REACT_APP_BASICSERVICE + "/api/pdf/customBind", {
        method: "POST",
        body: formData,
        headers: {
          prospectId: prospectID, // If you need to send this as a header as well
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.json(); // Expecting a JSON response with the payment link
        })
        .then((data) => {
          setPaymentLoading(false);
          // Redirect user to the payment link
          if (data.paymentLink) {
            window.location.href = data.paymentLink; // Redirect user to Stripe payment page
          } else {
            throw new Error("Payment link is missing in the response");
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("Error processing your request. Please try again.");
        });
    });

    // try {
    //   const response = await fetch(
    //     "http://localhost:4021/api/pdf/create-payment-link",
    //     {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify({
    //         price: total,
    //         insurerId: insurerSelectedId,
    //       }),
    //     }
    //   );

    //   // Check if the response is successful
    //   if (response.ok) {
    //     const data = await response.json();
    //     // Assuming 'data.url' is the payment link URL received from the server
    //     console.log("Payment Link:", data.url);

    //     // Redirect user to the payment link
    //     window.open(data.url, "_blank");
    //   } else {
    //     // Handle errors if the response is not successful
    //     console.error(
    //       "Failed to fetch the payment link",
    //       await response.text()
    //     );
    //     alert("Error fetching payment link. Please try again.");
    //   }
    // } catch (error) {
    //   console.error("Error during fetch:", error);
    //   alert("An error occurred while creating the payment link.");
    // }
    // pdfMake.createPdf(dd).download("my_document.pdf");
  }
  useEffect(() => {
    const fetchInsurerData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          process.env.REACT_APP_BASICSERVICE +
            "/api/prospects/getCustomBindPaymentInformation",
          {
            method: "POST", // Specify the method
            headers: {
              "Content-Type": "application/json", // Set the headers to inform server about the data type
            },
            body: JSON.stringify({
              prospectId: prospectID, // ES6 shorthand for prospectId: prospectId
              insurerId: insurerSelectedId, // ES6 shorthand for insurerId: insurerId
            }),
          }
        );
        if (response.ok) {
          const data = await response.json();

          const invoiceData = {
            serviceName: data.prospectDoc.answers.operations.list[0].name.en,
            premium: data.insurerInfo.coversasis[206],
            insurerFees: data.insurerInfo.coversasis[4],
            brokerFees: data.insurerInfo.coversasis[207],
            premiumAndFees: data.insurerInfo.coversasis[3],
            commissionRate: data.insurerInfo.coversasis[208],
            additionalFees:
              (Number(data.insurerInfo.coversasis[4]) || 0) +
              (Number(data.insurerInfo.coversasis[207]) || 0) +
              (Number(brokerFees) || 0),
            taxRate: tax,
            brokerInfo: data.brokerInfo,
          };

          console.log("new big ida", data);
          setDd({
            content: [
              {
                // Stack for header and border
                stack: [
                  {
                    // Canvas for the border
                    canvas: [
                      {
                        type: "rect",
                        x: 0,
                        y: -5,
                        w: 515, // Width of the border - adjust as needed
                        h: 75, // Height of the border - adjust as needed
                        lineWidth: 1,
                        lineColor: "black",
                      },
                    ],
                    // Absolute position is required to place canvas behind the columns
                    absolutePosition: { x: 40, y: 60 }, // Adjust position as needed
                  },
                  {
                    // Header Columns
                    columns: [
                      {
                        // Lloyds Logo Placeholder
                        image: "data:image/png;base64," + base64Image,
                        width: 100,
                        margin: [0, 10, 2, 0],
                      },
                      {
                        // Insurance Details
                        stack: [
                          {
                            text: "COMMERCIAL LEGAL EXPENSE INSURANCE",
                            bold: false,
                            fontSize: 10,
                          },
                          {
                            text: "Covered with certain Lloyd's Underwriters through Lloyd's Approved",
                            fontSize: 10,
                          },
                          {
                            text: "Coverholder (“the Coverholder”):",
                            fontSize: 10,
                          },
                          {
                            text: "Approved Casualty and Surety Inc.",
                            fontSize: 10,
                          },
                          {
                            text: "6601 Goreway Drive, Unit A, Mississauga ON L4V 1V6",
                            fontSize: 10,
                          },
                        ],
                        fontSize: 12,
                        margin: [40, 10, 0, 0],
                      },
                    ],
                    // Relative position to move the columns inside the border
                    relativePosition: { x: 40, y: 15 }, // Adjust position as needed
                  },
                ],
                // Required to prevent other content from overlapping with the header
                margin: [0, 0, 0, 50], // Bottom margin to push content below the header
              },

              {
                // Policy Notice
                text: "THIS POLICY CONTAINS A CLAUSE WHICH MAY LIMIT THE AMOUNT PAYABLE.",
                bold: true,
                fontSize: 18,
                alignment: "center",
                margin: [10, 80, 5, 5],
              },
              {
                // Policy Notice
                text: "DECLARATIONS",
                bold: true,
                fontSize: 13,
                alignment: "center",
                margin: [0, 30, 0, 15],
              },
              {
                // Declarations
                stack: [
                  {
                    text: "POLICY NO: " + policyNumber,
                    alignment: "right",
                    fontSize: 12,
                    margin: [0, 0, 0, 10],
                    bold: true,
                  },
                  {
                    // When you want to combine text and styles, make sure each part is correctly structured
                    text: [
                      {
                        text: "INSURED NAME: ",
                        bold: true,
                        fontSize: 12,
                        margin: [0, 4, 0, 0],
                      },
                      {
                        text: data.prospectDoc.cleanedanswers[10101],
                        bold: false,
                        fontSize: 12,
                        margin: [0, 4, 0, 0],
                      },
                    ],
                  },
                  {
                    text: [
                      {
                        text: "INSURED ADDRESS: ",
                        bold: true,
                        fontSize: 12,
                        margin: [0, 4, 0, 0],
                      },
                      {
                        text:
                          data.prospectDoc.cleanedanswers["10505_street1"] +
                          "," +
                          data.prospectDoc.cleanedanswers["10505_province"] +
                          ",",
                        bold: false,
                        fontSize: 12,
                        margin: [0, 4, 0, 0],
                      },
                    ],
                    margin: [0, 4, 0, 0],
                  },
                  {
                    text: "PERIOD OF INSURANCE:",
                    fontSize: 12,
                    margin: [0, 4, 0, 0],
                    bold: true,
                  },
                  {
                    text: [
                      { text: "from: ", bold: true, fontSize: 12 },
                      { text: periodFrom, bold: false, fontSize: 12 },
                    ],
                    margin: [103, 4, 0, 0],
                  },
                  {
                    text: [
                      { text: "to: ", bold: true, fontSize: 12 },
                      { text: periodTo, bold: false, fontSize: 12 },
                    ],
                    margin: [119, 4, 0, 10],
                  },
                  {
                    text: [
                      {
                        text: "(both days at 12:01 a.m. Standard Time at the Address of the Insured).",

                        fontSize: 10,
                      },
                    ],
                    margin: [128, 0, 0, 10],
                  },

                  {
                    text: [
                      { text: "PREMIUM: ", bold: true, fontSize: 12 },
                      {
                        text: premium.toString(),
                        bold: false,
                        fontSize: 12,
                        margin: [20, 0, 0, 20],
                      },
                    ],
                  },

                  {
                    table: {
                      headerRows: 1,
                      widths: ["*", "auto"], // First column fills remaining space, second is as wide as its content

                      body: [
                        // Header row
                        [
                          { text: "Type of Liability", style: "tableHeader" },
                          { text: "Amount", style: "tableHeader" },
                        ],
                        // Data rows
                        [
                          "Any One Claim",
                          data.insurerInfo.coversasis[186] || "-",
                        ],
                        ["Aggregate Limit", "$100,000"],
                        ["Deductible (Standard)", "$500"],
                        [
                          "Deductible (Contractor/Construction Industry Insureds)",
                          data.insurerInfo.coversasis[180] || "-",
                        ],
                        [
                          "Deductible for Legal Advice Service",
                          data.insurerInfo.coversasis[462] || "-",
                        ],
                      ],
                    },
                    layout: "lightHorizontalLines", // This adds horizontal lines between rows
                    margin: [0, 5, 0, 20], // Margins for the entire table
                    style: "tableStyle",
                  },
                  {
                    text: "POLICY COVERAGE:",
                    fontSize: 14,
                    margin: [0, 0, 0, 10],
                    bold: true,
                  },
                  {
                    ul: coverage.map((cover) => ({
                      text: cover,
                      fontSize: 11,
                    })),
                    margin: [20, 0, 0, 20],
                  },
                  {
                    text: "The insurance contract consists of this Declarations page as well as all coverage wordings, riders, or endorsements that are attached hereto.",
                    margin: [0, 10, 0, 0],
                    fontSize: 12,
                  },
                ],
              },
            ],
            styles: {
              header: {
                fontSize: 18,
                bold: true,
              },
              subheader: {
                fontSize: 15,
                bold: true,
              },
              quote: {
                italics: true,
              },
              small: {
                fontSize: 8,
              },
              tableHeader: {
                bold: true,
                fontSize: 12,
                margin: [0, 5, 0, 5], // Top, Right, Bottom, Left
                alignment: "left",
              },
              tableStyle: {
                margin: [0, 5, 0, 15],
              },
            },
          });
          setClientData(invoiceData); // Assuming you want to set the returned data as client data
        } else {
          console.error("Failed to fetch insurer data:", response.statusText);
          // Handle server errors or invalid responses here
        }
      } catch (error) {
        console.error("Error fetching insurer data:", error);
        // Handle network errors or exceptions here
      }
      setLoading(false);
    };

    // Call the function if both prospectId and insurerId are available
    if (prospectID && insurerSelectedId) {
      fetchInsurerData();
    }
  }, [prospectID, insurerSelectedId, base64Image]); // Include both prospectId and insurerId in the dependency array

  const handlePayment = async () => {
    // Payment handling logic
  };

  useEffect(() => {
    const { totalBeforeTax, taxPayable, totalPayable } = calculateTotal(
      clientData.premium,
      clientData.additionalFees,
      clientData.taxRate
    );
    console.log(
      "show the total amount",
      totalBeforeTax,
      taxPayable,
      totalPayable.toFixed(2)
    );
    setTotal(totalPayable);
  }, [clientData]);

  const calculateTotal = (premium, additionalFees, taxRate) => {
    const totalBeforeTax = premium + additionalFees;
    const taxPayable = totalBeforeTax * taxRate;
    const totalPayable = totalBeforeTax + taxPayable;

    return { totalBeforeTax, taxPayable, totalPayable };
  };

  const { totalBeforeTax, taxPayable, totalPayable } = calculateTotal(
    clientData.premium,
    clientData.additionalFees,
    clientData.taxRate
  );

  // if (loading) return <div>Loading...</div>;

  return (
    <>
      {!loading && !paymentLoading && (
        <div className="layout-container">
          <div className="payment-container">
            <div className="header-container">
              {" "}
              {/* New container for header and logo */}
              <h2>{clientData.brokerInfo.brokerageName}</h2>
              <img
                src={"/abcBorkerage.png"}
                alt="ABC Insurance Brokerage Logo"
                className="logo"
              />{" "}
              {/* Logo image */}
            </div>
            <div className="instruction-text">
              {/* <h2>ABC Insurance Brokerage</h2> */}
              <p>
                Here is a request for payment for your proposed insurance policy
                with Approved Casualty.
              </p>
              <p>
                You can securely make payment here by clicking the "Pay Now"
                button and adding details of your preferred payment card.
              </p>
              <p>
                Once payment has been made, your policy will be set-up and
                documents will be issued.
              </p>
              <p>
                If you have any questions about the payment or policy, please
                contact us at{" "}
                <a href={`mailto:${clientData.brokerInfo?.email}`}>
                  {" "}
                  {clientData.brokerInfo.email}
                </a>{" "}
                or call us on {clientData.brokerInfo?.phoneNumber}.
              </p>
            </div>
            <h2>Invoice to Client</h2>
            <table className="payment-breakdown">
              <tbody>
                <tr>
                  <td>Premium</td>
                  <td>${clientData.premium.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Fees</td>
                  <td>${clientData.additionalFees.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Total Premium & Fees</td>
                  <td>${totalBeforeTax.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Tax rate</td>
                  <td>{(clientData.taxRate * 100).toFixed(0)}%</td>
                </tr>
                <tr>
                  <td>Tax Payable</td>
                  <td>${taxPayable.toFixed(2)}</td>
                </tr>
                <tr>
                  <td>Total Payable</td>
                  <td>${totalPayable.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <div className="payment-form">
              {/* Date picker for selecting the effective date */}
              <h5>Effective Date</h5>
              <DatePicker
                selected={effectiveDate}
                onChange={handleDateChange}
                minDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                placeholderText="Select the effective date"
              />
            </div>
            <div className="payment-form">
              <button
                onClick={generatePdf}
                disabled={effectiveDate === null}
                className="payment-button"
              >
                Pay Now
              </button>
              {/* <button onClick={generatePdf}>Download PDF</button>; */}
            </div>
          </div>
        </div>
      )}
      {paymentLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
          <p style={{ marginLeft: "20px" }}>
            Redirecting you to the payment page, please wait...
          </p>
        </div>
      )}
    </>
  );
};

export default CustomPaymentComponent;
